import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import TagManager from "./TagManager";

const TagsPage = ({ buttonColor, currentLanguage }) => {
  const { userId } = useParams();
  return <TagManager userId={userId} buttonColor={buttonColor} currentLanguage={currentLanguage} />;
};

// Wrap with layout
const TagsPageWithLayout = () => (
  <WayfinderLayout>
    <TagsPage />
  </WayfinderLayout>
);

export default TagsPageWithLayout;
